export enum EOrganizationStatus {
    Disabled = 0,
    Enable = 1,
}
